import styled from 'styled-components';
import { ColDiv } from 'styles';

export const SubTitle = styled(ColDiv)`
  gap: 16px;
`;

export const Line = styled.span`
  display: inline-block;
  width: 4px;
  height: 20px;
  background-color: ${({ theme }) => theme.colors.primary100};
`;

export const GridDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 16px;
  column-gap: 24px;

  & > div:nth-last-child(1) {
    grid-column: 1 / span 2;
  }

  @media ${({ theme }) => theme.device.mobile} {
    display: flex;
    flex-direction: column;
  }
`;

export const Circle = styled.span`
  width: 3px;
  height: 30px;
  position: relative;
  display: inline-block;

  &::before {
    content: '';
    position: absolute;
    top: calc(50% - 1.5px);
    display: inline-block;
    min-width: 3px;
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.darker};
  }

  @media ${({ theme }) => theme.device.mobile} {
    height: 18px;
  }
`;

export const VideoContainer = styled.div`
  width: 100%;
  max-width: 1083px;
  margin: 0 auto;
`;

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.colors.boxShadow};

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media ${({ theme }) => theme.device.mobile} {
    border-radius: 4px;
  }
`;

export const VideoLink = styled.a`
  display: inline-block;
  margin-top: 16px;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
    text-decoration: underline;
  }

  @media ${({ theme }) => theme.device.mobile} {
    font-size: 0.8125rem;
    margin-top: 12px;
  }
`;

export const CertificationImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  img {
    width: 100%;
    max-width: 900px;
    height: auto;
    box-shadow: ${({ theme }) => theme.colors.boxShadow};
    border-radius: 8px;
    display: block;
  }

  @media ${({ theme }) => theme.device.tablet} {
    img {
      max-width: 100%;
    }
  }

  @media ${({ theme }) => theme.device.mobile} {
    img {
      max-width: 100%;
    }
  }
`;
